var MainscneConst = {
	MainacenBuild: {
	    shop        : 1,            //商城
	    mall        : 2,            //锻造屋
	    arena       : 3,            //竞技场
	    startower   : 4,            //星命塔
	    summon      : 5,            //召唤
	    fuse        : 6,            //融合祭坛 
	    guild       : 7,            //帮会
	    seerpalace  : 8,            //先知殿
	    video       : 9,            //军情期处
	    variety     : 10,           //杂货店
	    escort      : 11,           //限时活动
	},

	BuildItemType : {
		build : 1,
		effect : 2,
		npc : 3
	}

}

module.exports = MainscneConst;